import React from "react";
import { SEO, DynamicForm } from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class HiringPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      mfpqxdmkfibirjvxrekltrbabyjznexfyela,
      allFishermanBusinessLocation,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          ogUrl={"https://relaxedandradiantspa.com/hiring/"}
        />
        <Grid
          className={"custom-page-hiring custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"sztlgcnacxqpqdnf"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"eeddekkemxmzlpjc"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <DynamicForm
                  className={""}
                  style={{}}
                  businessId={42}
                  businessInfoId={1028}
                  websiteId={1037}
                  locationId={37}
                  componentConfigurationId={5817}
                  header={mfpqxdmkfibirjvxrekltrbabyjznexfyela.data.header}
                  fields={
                    mfpqxdmkfibirjvxrekltrbabyjznexfyela.data.dynamicFormFields
                  }
                  locations={allFishermanBusinessLocation.nodes}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 2467 }) {
      title
      components {
        files {
          file
        }
        order
        fastId
        componentIdentifier
      }
    }
    mfpqxdmkfibirjvxrekltrbabyjznexfyela: fishermanWebsiteComponent(
      fastId: { eq: "CustomForm" }
      componentIdentifier: { eq: "d2c64fa3-4b8f-474f-a47d-a58a1183de9f" }
    ) {
      data {
        header
        dynamicFormFields {
          name
          label
          options {
            label
            value
          }
          required
          inputType
          widgetType
          placeholder
          sendEmailToSelectedLocation
        }
      }
    }
    allFishermanBusinessLocation {
      nodes {
        _id
        city
        name
        street
      }
    }
  }
`;
